/* Commerce controls share the native Shopify forms and quantity rules. */
if (!customElements.get('trauemy-promotion')) customElements.define('trauemy-promotion', class extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController(); const signal = this.abort.signal;
    this.slides = [...this.querySelectorAll('[data-promo-slide]')]; this.index = 0;
    this.reduced = matchMedia('(prefers-reduced-motion: reduce)'); this.paused = this.reduced.matches;
    this.querySelector('[data-promo-prev]').addEventListener('click', () => this.show(this.index - 1), { signal });
    this.querySelector('[data-promo-next]').addEventListener('click', () => this.show(this.index + 1), { signal });
    this.querySelector('[data-promo-toggle]').addEventListener('click', () => { this.paused = !this.paused; this.toggleState(); }, { signal });
    this.addEventListener('pointerenter', () => this.hovered = true, { signal });
    this.addEventListener('pointerleave', () => this.hovered = false, { signal });
    this.reduced.addEventListener('change', () => { this.paused = this.reduced.matches; this.toggleState(); }, { signal });
    this.timer = setInterval(() => { if (!this.paused && !this.hovered && !document.hidden && !this.contains(document.activeElement)) this.show(this.index + 1); }, 6500);
    this.toggleState();
  }
  show(index) {
    this.index = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, i) => slide.hidden = i !== this.index);
  }
  toggleState() {
    const button = this.querySelector('[data-promo-toggle]');
    button.setAttribute('aria-pressed', String(this.paused));
    button.setAttribute('aria-label', this.paused ? button.dataset.play : button.dataset.pause);
    this.querySelector('[data-pause-icon]').hidden = this.paused;
    this.querySelector('[data-play-icon]').hidden = !this.paused;
  }
  disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); }
});
if (!customElements.get('trauemy-bundles')) customElements.define('trauemy-bundles', class extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController(); const signal = this.abort.signal;
    this.product = this.closest('product-info'); this.quantity = this.product?.querySelector('.quantity__input');
    if (!this.quantity) return;
    this.hidden = false;
    this.contents = this.querySelector('[data-tm-bundle-contents]');
    if (this.contents) this.contents.hidden = false;
    this.addEventListener('change', event => {
      if (!event.target.matches('input[type="radio"]')) return;
      this.quantity.value = event.target.value;
      this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
      this.sync();
    }, { signal });
    this.quantity.addEventListener('change', () => this.sync(), { signal });
    this.quantity.addEventListener('input', () => this.sync(), { signal });
    this.observer = new MutationObserver(() => this.sync());
    this.observer.observe(this.quantity, { attributes: true, attributeFilter: ['min', 'max', 'step', 'value'] });
    this.sync();
  }
  sync() {
    const value = Number(this.quantity.value);
    this.syncContents(Number.isSafeInteger(value) && value > 0 ? value : 1);
    this.querySelectorAll('input[type="radio"]').forEach(radio => { radio.checked = !radio.disabled && Number(radio.value) === value; });
  }
  syncContents(quantity) {
    if (!this.contents) return;
    const number = value => new Intl.NumberFormat(document.documentElement.lang || 'en').format(value);
    const values = {
      amount: number(Number(this.contents.dataset.unitAmount || 0) * quantity),
      count: number(Number(this.contents.dataset.unitCount || 0) * quantity),
      packs: number(Number(this.contents.dataset.unitPacks || 0) * quantity)
    };
    this.contents.textContent = this.contents.dataset.contentTemplate.replace(/\[(amount|count|packs)\]/g, (_, key) => values[key]);
  }
  disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
});

